import { addSeanceToFolder, getFolders } from "domain/folders/folders.actions";
import { selectIsFoldersLoading } from "domain/folders/folders.selectors";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";
import { PrimaryButton } from "ui/pages/app/components/buttons/PrimaryButton";
import { Snackbar } from "ui/pages/snackbar";
import { useWindowWidth } from "ui/utils/hooks";

interface IProps {
  selectedFolderSeances: number[];
  onCancel: () => void;
  folderId: number;
}

export function FolderFinishFooter({
  selectedFolderSeances,
  onCancel,
  folderId,
}: IProps) {
  const isDesktop = useWindowWidth();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsFoldersLoading);

  const handleAddClick = async () => {
    selectedFolderSeances.forEach(async (seanceId) => {
      const result = await dispatch(
        addSeanceToFolder({ folderId, seanceId })
      ).unwrap();
      if (result.success) {
        Snackbar.showSuccess({
          title: translate("ns1:Folders.AddedToFolder"),
        });
      }
    });
    await dispatch(getFolders()).unwrap();
    onCancel();
  };

  return (
    <div className="flex w-full flex-col items-center justify-center space-x-0 space-y-4 bg-white p-4 md:flex-row md:space-x-6 md:space-y-0">
      <PrimaryButton
        height={isDesktop ? "56px" : "46px"}
        width="100%"
        onClick={handleAddClick}
        disabled={selectedFolderSeances.length === 0 || isLoading}
      >
        {translate("ns1:Folders.AddToFolder")}
      </PrimaryButton>
      <PrimaryButton
        height={isDesktop ? "56px" : "46px"}
        width="100%"
        onClick={onCancel}
        disabled={isLoading}
        outlined
      >
        {translate("ns1:Button.Cancel")}
      </PrimaryButton>
    </div>
  );
}
